// extracted by mini-css-extract-plugin
export default {"container":"detailCardBtn_container__H68A9"};